<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
<!--                <div class="mb-5 w-100">-->
<!--                    <button class="btn btn-primary float-right " @click="onLinkAndUnlinkClick">Link Or Unlink Customer To Discount Group</button>-->
<!--                </div>-->
                <data-table :headings="customerDiscountGroupsHeadings" :data="customerDiscountGroups" :hasActions="tableHasActions"
                            :hasNoFilter="true"
                            :pagingDetails="pagingDetails"
                            :stateChanged="filterStateChanged"
                            @actionClicked="onCustomerDiscountGroupActionClicked" @filterSearchClicked="onFilterSearchClicked">
                </data-table>
            </div>
        </div>
    </div>
    <confirm-delete-modal
        :elementId="customerDiscountUnlinkCustomerModal.modalId"
        :message="customerDiscountUnlinkCustomerModal.message"
        :showModal="customerDiscountUnlinkCustomerModal.showModal"
        :loading="customerDiscountUnlinkCustomerModal.isSaving"
        :modalTitle="'Unlink?'"
        @deleteConfirmed="onConfirmUnlinkClick"></confirm-delete-modal>
    
    <success-modal
        :modalHeading="'Success'"
        :elementId="'successModal'"
        :modalMessage="successMessage"
        :showModal="showSuccessMessage"
        @okClicked="onSuccessModalOkClick"></success-modal>
    
    <error-modal
            :modalHeading="'Error'"
            :elementId="'errorModal'"
            :modalMessage="errorMessage"
            :showModal="showErrorMessage"
            @okClicked="onErrorModalOkClick"></error-modal>
    
    <link-unlink-customers-to-discount-group
            :companyId="companyId"
            :elementId="linkAndUnlinkDiscountGroupModal.modalId"
            :showModal="linkAndUnlinkDiscountGroupModal.showModal"
            @saveComplete="onLinkingSave"
            @modalClose="onLinkAndUnlinkModalClose"></link-unlink-customers-to-discount-group>
        
</div>
